import React, { useState } from 'react';
import { SBChatShow, SBChatChannel } from '../stores/SBChatStore';
import { apiClient } from '../../../shared/utils/apiClient';

interface SendMessageButtonProps {
  job_application_id: number;
  authenticity_token: string;
  user_signed_in: boolean;
}

interface CreateChatResponse {
  channel_url?: string;
  error?: string;
}

const SendMessageButton: React.FC<SendMessageButtonProps> = ({
  job_application_id,
  authenticity_token,
  user_signed_in
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSendMessage = async () => {
    if (!user_signed_in) {
      window.location.href = '/users/sign_in';
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.post<CreateChatResponse>(
        `/api/v1/job_applications/${job_application_id}/create_chat`,
        {},
        {
          headers: {
            'X-CSRF-Token': authenticity_token,
          },
        },
      );

      if (response.ok && response.data?.channel_url) {
        // Open SendBird chat using the nanostores
        SBChatChannel.set(response.data.channel_url);
        SBChatShow.set(true);
      } else {
        setError(response.data?.error || response.error || 'Failed to create chat');
      }
    } catch (err) {
      console.error('Error creating chat:', err);
      setError('Network error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className={`job-btn job-btn--primary ${loading ? 'job-btn--disabled' : ''}`}
        onClick={handleSendMessage}
        disabled={loading}
      >
        <i className="fa fa-envelope"></i>
        {' '}{loading ? 'Creating Chat...' : 'Send Message'}
      </button>

      {error && (
        <div className="alert alert-danger mt-2" style={{ fontSize: '12px' }}>
          {error}
        </div>
      )}
    </>
  );
};

export default SendMessageButton;
